import React from 'react';
import { Container } from 'react-bootstrap';
import styled from 'styled-components';
import {
  BREAKPOINTS,
  TEXT_PRIMARY,
  TEXT_SECONDARY,
} from '../../core/constants';
import useTranslation from '../../hooks/useTranslation';
import { LocalesUnion } from '../../types/interfaces';

interface CProps {
  locale: LocalesUnion;
}

const Title = styled.h2`
  -webkit-font-smoothing: antialiased;
  font-weight: bold;
  text-align: center;
  color: ${TEXT_PRIMARY};
  flex: 1;

  @media ${BREAKPOINTS.lg} {
    font-size: 30px;
  }
`;

const Subtitle = styled.p`
  -webkit-font-smoothing: antialiased;
  font-size: 20px;
  text-align: center;
  color: ${TEXT_SECONDARY};
`;

const Box = styled(Container)`
  display: flex;
  flex-direction: column;
`;

const ContactUs: React.FC<CProps> = ({ locale }) => {
  const { t } = useTranslation(locale);

  return (
    <Box>
      <Title>{t('HOMEPAGE_CONTACT_TITLE')}</Title>
      <Subtitle>{t('HOMEPAGE_CONTACT_DESC')}</Subtitle>
    </Box>
  );
};

export default ContactUs;
